export default {
    
    horizontalSeparatorContainer: {
        marginTop: "20px",
        marginBottom: "20px"
    },
    titleCustomStyles: {
        fontSize: "30px",
        textDecoration: "underline",
        paddingBottom: "15px",
    },
    finalSubmitBtn: {
        marginBottom: "20px",
    },
    switchContainer: {
        display: "flex",
        alignItems: "center",
        marginLeft: "auto",
    },
    switchSpan: {
        marginRight: "8px",
        display: "flex",
    },
    switchLabelCustomStyle: {
        width: "28px",
        height: "14px",
    },
    switchButtonCustomStyle: {
        top: "1px",
        width: "10px",
        height: "10px",
    },
    headerRow: {
        display: "flex",
        justifyContent: "space-between",
    }
}